import { Ranking, RankingMe } from "../interfaces/ranking";
import { RankingStudent } from "../interfaces/ranking-student";

export class EmptyRanking implements Ranking {
  results: Array<RankingStudent> = [];
  page: number = 0;
  page_last: number = 1;
  position_last: number = 0;
  me: RankingMe | null = null;
}
